import styled from "styled-components";

const GradientBorder = styled.div`
  height: 10px;
  background: linear-gradient(315deg, #39d0c5 0%, #764ef2 100%);
`;

export default GradientBorder;
